"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLogRocketCookie = exports.LOG_ROCKET_COOKIE = void 0;

var _storage = require("../storage");

var LOG_ROCKET_COOKIE = 'zola-lgrkt';
exports.LOG_ROCKET_COOKIE = LOG_ROCKET_COOKIE;

var setLogRocketCookie = function setLogRocketCookie(projectName) {
  var cookieDurationDays = 0.02; // ~30 minutes

  (0, _storage.setCookie)(LOG_ROCKET_COOKIE, projectName, cookieDurationDays);
};

exports.setLogRocketCookie = setLogRocketCookie;